import React, { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import MyModal from '../../../../UI/modal/MyModal'
import UserInSupplyOrderForm from './UserInSupplyOrderForm'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

const EditUserInSupplyOrderButton = ({ supplyOrderId, user }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            size='smExtra'
            onClick={e => setOpen(true)}
        >
            {
                user ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={user ? 'Редагувати відповідального' : 'Додати відповідального'}
            disableClickOutside={true}
            content={
                <UserInSupplyOrderForm
                    supplyOrderId={supplyOrderId}
                    userBd={user}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default EditUserInSupplyOrderButton